__turbopack_context__.v({
  "container": "BlockEdd-module__eszDTq__container",
  "eddTimeRangeContainer": "BlockEdd-module__eszDTq__eddTimeRangeContainer",
});
